<div class="error-layout">
  <div class="box">
    <div class="box-error">
      <img src="assets/img/brand/alpuraAzHzMin.svg" width="250">
    </div>
    
    <div class="box-error-text">
      <div class="box-error-text-container">
        <div class="box-error-text-title">Error 404</div>
        <div class="box-error-text-text">No se encontro el recurso solicitado</div>
      </div>
      
      <a href="" target="_blank" class="box-error-button">Regresar</a>
      
    </div>
    
  </div>
</div>
